import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import VisibilitySensor from 'react-visibility-sensor'
import { useSelector } from 'react-redux'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import iconTrivia from '../../images/png/types/icon__trivia.svg'
import iconPhotostory from '../../images/png/types/icon__photostory.svg'
import iconMemory from '../../images/png/types/icon__memory.svg'
import iconQuotes from '../../images/png/types/icon__quotes.svg'
import iconPersonality from '../../images/png/types/icon__personality.svg'
import iconRankBattle from '../../images/png/types/icon__rank-battle.svg'
import iconBeforeAfter from '../../images/png/types/icon__before-after.svg'
import iconTimeline from '../../images/png/types/icon__timeline.svg'
import iconZoomMap from '../../images/png/types/icon__zoom-map.svg'

import { API__TYPES } from '../../api'
import { API__TEMPLATES } from '../../api'

import { types_translations } from '../../utils/crutchTranslations'

const icons = {
    TRIVIA: iconTrivia,
    PERSONALITY: iconPersonality,
    BEFORE_AFTER: iconBeforeAfter,
    MEMORY: iconMemory,
    PHOTOSTORY: iconPhotostory,
    QUOTES: iconQuotes,
    RANK_BATTLE: iconRankBattle,
    TIMELINE: iconTimeline,
    ZOOM_MAP: iconZoomMap,
}

const TemplatesBlock = ({
    additionalClass = '',
    title,
    subtitle,
    customId = null,
    showType = false,
    topOffsetRequest = 0,
    t,
}) => {
    const [templates, setTemplates] = useState([])
    const [requested, setRequested] = useState(false)

    async function fetch() {
        let response
        if (customId) {
            response = await API__TEMPLATES.GET_TEMPLATES(customId.toUpperCase(), {
                sort: 'orderNumber,asc',
                page: 0,
                size: 500,
                isMinimal: false,
            })
        } else {
            response = await API__TYPES.GET_TEMPLATES({
                per_page: 8,
                offset_pages: 0,
                sort: 'orderNumber,asc',
                is_minimal: false,
            })
        }
        if (response && !response.empty) {
            setTemplates(response.content)
        }
    }

    useEffect(() => {
        if (requested) {
            setTemplates([])
            fetch()
        }
    }, [customId])

    function onChange(isVisible) {
        if (isVisible && !requested) {
            setRequested(true)
            fetch()
        }
    }

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 1196,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
            {
                breakpoint: 920,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 636,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    }

    const language = useSelector(state => state.language)

    return (
        <div className="templates-wrapper">
            <VisibilitySensor onChange={onChange}>
                <div className="checker" style={{ top: `${topOffsetRequest}px` }}></div>
            </VisibilitySensor>
            <div className={`__templates-block ${additionalClass}`}>
                <h3 className="dark">{title}</h3>
                <p>{subtitle}</p>
                {templates.length ? (
                    <Slider className="carousel" {...settings}>
                        {templates.map(template => {
                            return (
                                <div className="slide-wrap" key={template.id}>
                                    <div
                                        className="image"
                                        style={{ backgroundImage: `url(${template.projectImage})` }}
                                    ></div>
                                    {showType ? (
                                        <div className="type">
                                            <p
                                                style={{
                                                    color: template.projectType.color,
                                                    borderColor: template.projectType.color,
                                                }}
                                            >
                                                <img src={icons[template.projectType.customId]} alt="" />
                                                {/* START > Временно пока нет многоязычности в админке */}
                                                {
                                                    types_translations[template.projectType.customId].name[
                                                        language.split('-')[0]
                                                    ]
                                                }
                                                {/* END */}

                                                <Link
                                                    className="link"
                                                    to={`/template-gallery?type_id=${template.projectType.id}`}
                                                ></Link>
                                            </p>
                                        </div>
                                    ) : null}
                                </div>
                            )
                        })}
                    </Slider>
                ) : (
                    <div className="local-loading">
                        <div className="lds-ellipsis">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                )}
                <div className="link">
                    <Link
                        to={!customId ? '/template-gallery' : `/template-gallery/${customId}`}
                        className="button-style"
                        data-size="lg"
                        data-variant="primary"
                    >
                        {t('_components._templates.all_templates')}
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default withTranslation('translations')(TemplatesBlock)
